<app-nav-cliente></app-nav-cliente>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-7">
            <h5>Datos Generales</h5>
            <div class="row">
                <div class="col-lg-4">
                    {{datosGrupo.nombre}}<br>
                    {{datosGrupo.escuela}}<br>
                    {{datosGrupo.carrera}}<br>
                    <a href="{{datosGrupo.link_whatsapp}}" target="_blank">Link Grupo What's App</a><br>
                </div>
                <div class="col-lg-7">
                    <div class="row">
                        <div class="col-lg-6">
                            <div *ngIf="datosGrupo.escudo == ''; else escudouno">
                                <img src="assets/img/auri.png" width="200px">
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <div *ngIf="datosGrupo.escudo2 == ''; else escudodos">
                                <img src="assets/img/auri.png" width="200px">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6">
                            <ng-template #escudouno>
                                <ng-container>
                                    <img src="{{enviroment}}{{datosGrupo.escudo}}" width="100%">
                                </ng-container>
                            </ng-template>
                        </div>

                        <div class="col-lg-6">
                            <ng-template #escudodos>
                                <ng-container>
                                    <img src="{{enviroment}}{{datosGrupo.escudo2}}" width="100%">
                                </ng-container>
                            </ng-template>  
                        </div>
                    </div>                    
                </div>
                <!-- <div class="col-lg-3">
                    <img src="assets/img/auri.png" width="100%">
                </div> -->
            </div>

            <h5>Fechas Importantes</h5>

            <p>    
                <span class="bold">Fechas de pagos</span><br>
                {{datosGrupo.fecha_pago_uno}}<br>
                {{datosGrupo.fecha_pago_dos}}<br>
                <span *ngIf="datosGrupo.forma_pago == 2">{{datosGrupo.fecha_pago_tres}}<br></span>
            </p>

            <h5>Datos de Foto</h5>
            <p>{{datosGrupo.fecha_foto}} a las {{datosGrupo.hora_toma_foto}} en {{datosGrupo.lugar_toma_foto}}</p>

            <h5>Entrega de paquetes</h5>
            <p>{{datosGrupo.fecha_entrega}} en {{datosGrupo.lugar_entrega}}</p> 
        </div>
        <div class="col-lg-3">
            <app-mi-paquete></app-mi-paquete>
        </div>
        <div class="col-lg-1"></div>
    </div>
</div>